import React, { FC, useContext, useEffect, useState } from "react";

import { GetProfileResponse } from "../../models/get-profile-response";

import { useReturnUrl } from "../../hooks/use-return-url";

import { getProfile } from "../../apis/get-profile";

import { AppContext } from "../../../app-context";
import Page from "../../components/page/page";
import ProfileForm from "../../components/profile-form/profile-form";

const Profile: FC = () => {
  const { hashedReturnUrl, returnToPreviousUrl } = useReturnUrl();
  const [profile, setProfile] = useState<GetProfileResponse>();
  const { account } = useContext(AppContext);

  useEffect(() => {
    const loadProfile = async () => {
      const profile = await getProfile("profile");
      setProfile(profile);
    };
    loadProfile();
  }, []);

  const updateProfile = (email: string, countryCode: string, phoneNumber: string, newsletterConsent: boolean) => {
    const updatedProfile: GetProfileResponse = {
      mobile: phoneNumber,
      email: email,
      countryCode: countryCode,
      newsletterConsent: newsletterConsent
    };
    setProfile(updatedProfile);
  };

  return (
    <Page inputs={[profile]} showMenu={account?.isVerified}>
      {profile && (
        <ProfileForm
          setProfile={updateProfile}
          email={profile.email}
          newsletterConsent={profile.newsletterConsent}
          countryCode={profile.countryCode}
          phoneNumber={profile.mobile}
          hashedReturnUrl={hashedReturnUrl}
          returnToPreviousUrl={returnToPreviousUrl}
        />
      )}
    </Page>
  );
};

export default Profile;
